import type { AccessPair } from '@/shared/lib'

/*
 * Пары прав ручек заказов — зеркало `@ActingAs` бэка (`src/orders/orders.controller.ts`,
 * `docs/roles/02-backend-contract.md` §2). Меняется у бэка — меняется здесь.
 */

/** `GET /v1/orders`: резервы и счета. `full` появится, когда бэк реализует `BE-40`. */
export const ORDERS_ACCESS: AccessPair = {
  own: 'order.view',
  onBehalf: 'manager.orders.view',
  accepts: ['account'],
}

/** `GET /v1/orders/invoices`: счета для дозаказа. `settlement` здесь — параметр ручки, не модификатор. */
export const INVOICES_ACCESS: AccessPair = {
  own: 'order.view',
  onBehalf: 'manager.orders.view',
  accepts: ['account', 'unp'],
}

/**
 * Оформление резерва клиентом: `POST /v1/orders/from-cart` (и `from-list`, дозаказ в счёт) —
 * своё право `order.create`, не право чтения. Модификатора ручки не принимают: у менеджера
 * оформление — корзины за клиентов (`manager.order.create`).
 */
export const ORDER_CREATE_ACCESS: AccessPair = { own: 'order.create' }

/**
 * Подтверждение черновика заказного каталога РБ: `POST /v1/orders/lines/confirm` — своё право
 * `order.create`, от имени клиента `manager.order.create` (и признак «Заказной каталог», который
 * закрывает и просмотр раздела `catalog.order.view`). Принимает `account`.
 */
export const ORDER_CONFIRM_ACCESS: AccessPair = {
  own: 'order.create',
  onBehalf: 'manager.order.create',
  accepts: ['account'],
}

/** Правка количества, удаление строк, комментарий, письмо — `ORDERS_EDIT` бэка. */
export const ORDER_EDIT_ACCESS: AccessPair = {
  own: 'order.edit',
  onBehalf: 'manager.order.edit',
  accepts: ['account'],
}

/** `POST /v1/orders/write-off`. Менеджер списывает всегда, клиент — по признаку `spisat_tovar`. */
export const WRITE_OFF_ACCESS: AccessPair = {
  own: 'invoice.write-off',
  onBehalf: 'manager.invoice.write-off',
  accepts: ['account'],
}
